import { AbstractPageDataProvider } from "@/lib/utility/data/page-data-provider.abstract";
import { IPageViewModel } from "@/lib/utility/data/page-view-model.interface";
import { IReportGroup } from "@/models/report-group.entity";
import reportGroupService from "@/services/mrfiktiv/services/report-group.service";
import { MrfiktivReportGroupControllerGetParamsGen } from "@/services/mrfiktiv/v1/data-contracts";

export const ReportGroupPageDataProvider = new (class extends AbstractPageDataProvider<
  IReportGroup,
  MrfiktivReportGroupControllerGetParamsGen
> {
  itemsPerPage = 250;

  async getPage(query: MrfiktivReportGroupControllerGetParamsGen): Promise<IPageViewModel<IReportGroup>> {
    const res = await reportGroupService.get(query);

    const meta = res.meta;
    const data = (res.data ?? []) as IReportGroup[];

    return { meta, data };
  }
})();
